import React from "react";
import { Layout, Row, Col } from "antd";
import { ReactSVG } from "react-svg";
import ShowIcon from "../../../images/icons/Icons";
import {
  facebook,
  twitter,
  reddit,
  telegram,
  discord,
} from "../../../images/footer/FooterImages";
import "./AppFooter.scss";
const { Footer } = Layout;

const learn = [
  {
    text: "Centric Basics",
    link: "https://www.centric.com/basics/",
  },
  {
    text: "Roadmap",
    link: "https://www.centric.com/centric-roadmap/",
  },
  {
    text: "Whitepaper",
    link: "https://www.centric.com/whitepaper/",
  },
  {
    text: "Key Metrics",
    link: "https://www.centric.com/metrics/",
  },
  {
    text: "Guide",
    link: "https://www.centric.com/guide/",
  },
  {
    text: "FAQ's",
    link: "https://www.centric.com/faq-general/",
  },
];

const about = [
  {
    text: "Centric Foundation",
    link: "https://www.centric.com/about/",
  },
  {
    text: "News & Events",
    link: "https://www.centric.com/news-events/",
  },
  {
    text: "Careers",
    link: "https://www.centric.com/careers/",
  },
  {
    text: "Press Releases",
    link: "https://www.centric.com/press-releases/",
  },
  {
    text: "Contact Us",
    link: "https://www.centric.com/contact-us",
  },
];

const resources = [
  {
    text: "Resource Portal",
    link: "https://portal.centric.com/",
  },
  {
    text: "Developer Hub",
    link: "https://www.centric.com/centric-hub/",
  },
  {
    text: "Centric Swap",
    link: "https://www.centricswap.com/",
  },
  {
    text: "Centric Wallet",
    link: "https://wallet.centric.com/",
  },
  {
    text: "Support",
    link: "https://www.centric.com/support/",
  },
];

const socials = [
  {
    text: "Facebook",
    link: "https://www.facebook.com/JoinCentric/",
    icon: facebook,
  },
  {
    text: "Twitter",
    link: "https://twitter.com/JoinCentricApp",
    icon: twitter,
  },
  {
    text: "Reddit",
    link: "https://www.reddit.com/user/joincentric",
    icon: reddit,
  },
  {
    text: "Telegram",
    link: "https://t.me/centric",
    icon: telegram,
  },
  {
    text: "Telegram Chat",
    link: "https://t.me/CentricChat",
    icon: telegram,
  },
  {
    text: "Discord",
    link: "https://discord.gg/KjwY64h",
    icon: discord,
  },
];

export default function AppFooter() {
  return (
    <Footer className="AppFooter">
      <div className="container">
        <Row gutter={32}>
          <Col lg={7} md={8} sm={24} xs={24}>
            <ShowIcon icon={"logo_full"} />
            <p className="AppFooter__text">
              Centric is an innovative dual-token digital currency and
              decentralized blockchain protocol built on sound economics. The
              dual-token model rewards adoption and stabilizes over time as it
              self-regulates token supply to meet ongoing changes in demand.
            </p>
          </Col>
          <Col
            lg={{ span: 4, offset: 1 }}
            md={{ span: 4, offset: 0 }}
            sm={6}
            xs={8}
          >
            <p className="AppFooter__header">Learn</p>
            <ul className="AppFooter__list">
              {learn.map((item, index) => (
                <li className="AppFooter__list__item" key={index}>
                  <a href={item.link} target="_blank" rel="noopener noreferrer">
                    {item.text}
                  </a>
                </li>
              ))}
            </ul>
          </Col>
          <Col lg={4} md={4} sm={6} xs={8}>
            <p className="AppFooter__header">About</p>
            <ul className="AppFooter__list">
              {about.map((item, index) => (
                <li className="AppFooter__list__item" key={index}>
                  <a href={item.link} target="_blank" rel="noopener noreferrer">
                    {item.text}
                  </a>
                </li>
              ))}
            </ul>
          </Col>
          <Col lg={4} md={4} sm={6} xs={8}>
            <p className="AppFooter__header">Resources</p>
            <ul className="AppFooter__list">
              {resources.map((item, index) => (
                <li className="AppFooter__list__item" key={index}>
                  <a href={item.link} target="_blank" rel="noopener noreferrer">
                    {item.text}
                  </a>
                </li>
              ))}
            </ul>
          </Col>
          <Col lg={4} md={4} sm={6} xs={24}>
            <p className="AppFooter__header">Socials</p>
            <ul className="AppFooter__list AppFooter__list--social">
              {socials.map((item, index) => (
                <li
                  className="AppFooter__list__item AppFooter__list__item--hasIcon"
                  key={index}
                >
                  <a href={item.link} target="_blank" rel="noopener noreferrer">
                    <ReactSVG src={item.icon} className="Social__icon" />
                    <div className="Social__text">{item.text}</div>
                  </a>
                </li>
              ))}
            </ul>
          </Col>
        </Row>
        <Row className="AppFooter__signoff" justify="space-between">
          <Col flex="auto">
            <ul className="AppFooter__signoff__list">
              <li>© 2019-2021 The Centric Corp Ltd. All rights reserved.</li>
            </ul>
          </Col>
          <Col flex="auto">
            <ul className="AppFooter__signoff__list AppFooter__signoff__list--end">
              <li>
                <a
                  href="https://www.centric.com/privacy-policy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
              </li>
              <li>
                <a
                  href="https://www.centric.com/terms-of-service/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms of service
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </div>
    </Footer>
  );
}
